import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { galleryApi } from '../services/api';
import type { GalleryYear } from '../types';

export default function LandingPage() {
  const [years, setYears] = useState<GalleryYear[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const fetchYears = () => {
    setError(null);
    setYears(null);
    galleryApi
      .getYears()
      .then((res) => setYears(res.years))
      .catch(() => setError('Failed to load gallery data. Please try again.'));
  };

  useEffect(() => {
    fetchYears();
  }, []);

  const helmet = (
    <Helmet>
      <title>FWO Photo Gallery</title>
      <meta name="description" content="Browse published photos from FlyWideOpen paragliding competitions" />
      <meta property="og:title" content="FWO Photo Gallery" />
      <meta property="og:description" content="Browse published photos from FlyWideOpen paragliding competitions" />
      <meta property="og:url" content={window.location.href} />
    </Helmet>
  );

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        {helmet}
        <p className="text-red-600 mb-4">{error}</p>
        <button
          onClick={fetchYears}
          className="rounded-md bg-fwo-blue px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 transition-colors"
        >
          Retry
        </button>
      </div>
    );
  }

  if (years === null) {
    return (
      <div className="flex items-center justify-center py-20">
        {helmet}
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-fwo-blue border-t-transparent" />
      </div>
    );
  }

  if (years.length === 0) {
    return (
      <div className="flex items-center justify-center py-20 text-center">
        {helmet}
        <p className="text-gray-500">No gallery photos available yet</p>
      </div>
    );
  }

  const mostRecentYear = years.reduce((max, y) =>
    Number(y.year) > Number(max.year) ? y : max
  );

  return <Navigate to={`/${mostRecentYear.year}`} replace />;
}
